// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"73fa96ec","443":"69ebae0f","545":"6dc9aae1","899":"bb117abb","905":"ed43d04b"}[chunkId] + ".chunk.js";
};